<template>
  <object v-if="movie.quote == 'amazon' && movie.ref_url">
    <a :href="movie.ref_url" class="amazon-af-link" target="_blank" rel="nofollow">Amazonで買う</a>
  </object>
  <div class="credit-box" v-else-if="movie.quote"><span>提供元：</span><span>{{ movie.quote }}</span></div>
</template>

<script>
export default {
  name: 'CreditBox',
  props: ['movie']
}
</script>

<style scoped lang="scss">
  .credit { min-height: 20px; }
  .credit-box {
    margin: 0;
    color: #b8b8b8;
    font-size: 1.0rem;
    text-align: center;
    white-space: normal;
  }
  .amazon-af-link {
    width: 88px;
    height: 20px;
    margin: 0 auto;
    border: 1px solid #757de0;
    border-radius: 4px;
    font-size: 1.1rem;
    font-weight: bold;
    text-align: center;
    line-height: 18px;
    box-sizing: border-box;
  }
</style>